import { render, staticRenderFns } from "./IolProgressBar.vue?vue&type=template&id=5831f0a0"
import script from "./IolProgressBar.vue?vue&type=script&lang=js"
export * from "./IolProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports